package com.isaias.fyattravel.web.layout
 
import androidx.compose.runtime.*
import kotlinx.browser.window
import org.w3c.dom.events.Event
 
data class ResponsiveState(
    val width: Int,
    val isMobile: Boolean,
    val isTablet: Boolean,
    val isDesktop: Boolean
)
 
@Composable
fun rememberResponsiveState(
    mobileMax: Int = 640,
    tabletMax: Int = 1024
): ResponsiveState {
    var width by remember { mutableStateOf(window.innerWidth) }
 
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = { width = window.innerWidth }
        window.addEventListener("resize", listener)
        onDispose { window.removeEventListener("resize", listener) }
    }
 
    val isMobile = width <= mobileMax
    val isTablet = width in (mobileMax + 1)..tabletMax
    return ResponsiveState(
        width = width,
        isMobile = isMobile,
        isTablet = isTablet,
        isDesktop = width > tabletMax
    )
}